import { lazy } from 'react';
const AggregateOverview = lazy(() => import('@/pages/overview/Index'));
const aggregateConfigRoute = [
    {
        path: "/aggregateOverview/:name/:code/:id",
        name: '预览页',
        component: AggregateOverview,
        multipleTab:"/aggregateOverview"
    },
]
export default aggregateConfigRoute